<template>
  <div>
    <px-view-header title="Cadastro de tipos de uso"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loadingTipoUso">
      <px-circular-loading/>
    </div>
    <v-container>
      <v-row dense>
        <v-col cols="12" sm="4">
          <v-text-field
            dense
            outlined
            hide-details
            maxlength="50"
            class="rounded-tag-small"
            label="Código interno"
            v-model="tipoUso.codigoInterno"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <v-text-field
            dense
            outlined
            required
            hide-details
            maxlength="100"
            class="required rounded-tag-small"
            label="Descrição"
            :error="$v.tipoUso.descricao.$error"
            @blur="$v.tipoUso.descricao.$touch()"
            v-model="tipoUso.descricao"
          />
        </v-col>
        <v-col cols="12" sm="2">
          <v-switch dense
                    hide-details
                    class="pa-0 mt-2 mr-2"
                    label="Ativo"
                    color="primary"
                    v-model="tipoUso.ativo"/>
        </v-col>
      </v-row>
      <div class="mt-5">
        <v-btn color="primary"
               class="normal-btn-text rounded-tag-small elevation-0"
               @click="onClickSave"
               :loading="loading">
          Salvar
        </v-btn>
        <v-btn text class="normal-btn-text" @click="onClickBack">Cancelar</v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import TipoUsoService from './tipos-uso-service';


export default {
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingTipoUso: false,
      tipoUso: {
        descricao: null,
        codigoInterno: null,
        ativo: true,
      },
      tipoUsoId: this.$route.params.id,
      breadcrumbs: [
        { text: 'Produtos' },
        { text: 'Tipos de uso' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.tipos-uso' });
    },
    getTipoUso() {
      this.loadingTipoUso = true;
      TipoUsoService.get(this.tipoUsoId)
        .then((response) => {
          this.tipoUso = response.data;
        })
        .finally(() => {
          this.loadingTipoUso = false;
        });
    },
    buildPayload() {
      const tipoUso = { ...this.tipoUso };
      tipoUso.descricao = this.tipoUso.descricao.trim();
      if (this.tipoUso.codigoInterno) {
        tipoUso.codigoInterno = this.tipoUso.codigoInterno.trim();
      }
      return tipoUso;
    },
    salvar() {
      this.loading = true;
      TipoUsoService.save(this.buildPayload())
        .then(() => {
          if (this.tipoUsoId) {
            this.$toast('Tipo de uso atualizado com sucesso', { color: 'success' });
          } else {
            this.$toast('Tipo de uso criado com sucesso', { color: 'success' });
          }
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickSave() {
      if (this.validateForm()) {
        return;
      }
      this.salvar();
    },
  },
  created() {
    if (this.tipoUsoId) {
      this.getTipoUso();
    }
  },
  validations: {
    tipoUso: {
      descricao: {
        required,
      },
    },
  },
};
</script>
